import React, { useEffect, useState } from "react";
import {
  useNewTicketNotificationMutation,
  useDeleteTicketNotificationMutation,
  useGetAutoTicketNotificationQuery,
  useGetManualTicketNotificationQuery,
  useUpdateTicketNotificationMutation,
} from "../../../../Services/settingsAPIs/TicketSettingsAPI";

import { toast } from "react-toastify";

interface IProps {
  selectedTeam: number;
  ticketNotificationsData: any;
  notificationType: string;
  selectedStatus: any;
  selectedWorkflow: number;
}

const AutoTicketRules: React.FC<IProps> = ({
  selectedTeam,
  ticketNotificationsData,
  notificationType,
  selectedStatus,
  selectedWorkflow,
}) => {
  const [triggerDeleteTicketNotification] =
    useDeleteTicketNotificationMutation();
  const initialValues = {
    team: String(selectedTeam),
    status_type: "",
    send_to: [],
    via: "",
    creator_template: "",
    assignee_template: "",
    customer_template: "",
    notification_type: notificationType,
  };

  const [triggerNewTicketNotificationConfig] =
    useNewTicketNotificationMutation();
  const [message, setMessage] = useState("");
  const [notificationConfig, setNotificationConfig] =
    useState<any>(initialValues);
  const [triggerEditTicketNotificationConfig] =
    useUpdateTicketNotificationMutation();
  const [isNewNotificationConfig, setIsNewNotificationConfig] = useState(false);
  const [notificationQueryParams, setNotificationQueryParams] = useState<any>(
    {}
  );

  // Derive notification query params directly from notificationConfig and selectedStatus
  const sendTo = notificationConfig?.send_to || [];
  const via = (() => {
    if (notificationConfig?.via) {
      return notificationConfig?.via;
    }
    return "";
  })();
  const selectedStatusType = (() => {
    if (notificationConfig?.status_type) {
      const status = selectedStatus?.find(
        (x: any) => x.uuid === notificationConfig.status_type
      );
      return status?.status_type || (sendTo.length > 0 ? sendTo[0] : "");
    }
    return sendTo.length > 0 ? sendTo[0] : "";
  })();
  const selectedStatusId = (() => {
    if (notificationConfig?.status_type) {
      const status = selectedStatus?.find(
        (x: any) => x.uuid === notificationConfig.status_type
      );
      if (status?.status_type === "closed" || status?.status_type === "wip") {
        return status?.status?.id || null;
      }
    }
    return null;
  })();

  // Only skip if selectedTeam, selectedWorkflow, sendTo, via, or selectedStatusType are missing (selectedStatusId can be empty)
  const shouldSkip =
    !selectedTeam ||
    !selectedWorkflow ||
    !sendTo.length ||
    !via ||
    !selectedStatusType;

  // Call both hooks unconditionally but use skip to control when they run
  const autoTicketQuery = useGetAutoTicketNotificationQuery(
    {
      selectedTeam,
      selectedWorkflow,
      sendTo,
      via,
      selectedStatusType,
      selectedStatusId,
    },
    { 
      skip: shouldSkip || notificationType !== "auto_ticket"
    }
  );

  const manualTicketQuery = useGetManualTicketNotificationQuery(
    {
      selectedTeam,
      selectedWorkflow,
      sendTo,
      via,
      selectedStatusType,
      selectedStatusId,
    },
    { 
      skip: shouldSkip || notificationType !== "manual_ticket"
    }
  );

  // Use the appropriate query result based on notification type
  const activeNotificationsData = notificationType === "auto_ticket" 
    ? autoTicketQuery.data 
    : manualTicketQuery.data;
    
  const isLoadingActiveNotificationData = notificationType === "auto_ticket"
    ? autoTicketQuery.isLoading
    : manualTicketQuery.isLoading;
    
  const refetchNotificationData = notificationType === "auto_ticket"
    ? autoTicketQuery.refetch
    : manualTicketQuery.refetch;

  const insertPlaceholder = (placeholder: string) => {
    const textareaId = notificationType === 'auto_ticket' ? 'auto-ticket-textarea' : 'manual-ticket-textarea';
    const textarea = document.querySelector(`#${textareaId}`) as HTMLTextAreaElement;
    if (textarea) {
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const text = textarea.value;
      const before = text.substring(0, start);
      const after = text.substring(end, text.length);
      const newText = before + placeholder + after;
      
      setNotificationConfig((prev: any) => {
        const field = `${prev.send_to[0].toLowerCase()}_template`;
        return {
          ...prev,
          [field]: newText
        };
      });

      // Set cursor position after the inserted text
      const newCursorPos = start + placeholder.length;
      setTimeout(() => {
        textarea.setSelectionRange(newCursorPos, newCursorPos);
        textarea.focus();
      }, 0);
    }
  };

  const removeProperty = (prop) => {
    const newObj = { ...notificationConfig };
    delete newObj[prop];
    setNotificationConfig(newObj);
  };

  function loadTemplateOf(sendto: string) {
    switch (sendto) {
      case "Creator":
        return notificationConfig.creator_template;
      case "Customer":
        return notificationConfig.customer_template;
      case "Assignee":
        return notificationConfig.assignee_template;
    }
  }

  console.log(notificationConfig, "notificationConfig");

  function handleRespectiveFieldtemplateUpdate(evt: any) {
    const { value } = evt.target;
    const field = `${notificationConfig.send_to[0].toLowerCase()}_template`;
    
    setNotificationConfig((prev: any) => ({
      ...prev,
      [field]: value
    }));
  }

  const handleWhenStatusInputChange = (e: any) => {
    const { name, value } = e.target;
    let existingNotificationFound = null;

    // Check for existing notification based on notification type
    if (notificationType === "auto_ticket" && ticketNotificationsData.auto) {
      existingNotificationFound = ticketNotificationsData.auto.find(
        (x: any) =>
          x.status_type === value &&
          x.send_to[0] == notificationConfig.send_to[0]
      );
    } else if (
      notificationType === "manual_ticket" &&
      ticketNotificationsData.manual
    ) {
      existingNotificationFound = ticketNotificationsData.manual.find(
        (x: any) =>
          x.status_type === value &&
          x.send_to[0] == notificationConfig.send_to[0]
      );
    }

    if (existingNotificationFound) {
      if (notificationConfig.send_to[0] === "Creator") {
        setNotificationConfig({
          ...notificationConfig,
          [name]: value,
          creator_template: existingNotificationFound.creator_template,
          id: existingNotificationFound.id,
        });
      } else if (notificationConfig.send_to[0] === "Customer") {
        setNotificationConfig({
          ...notificationConfig,
          [name]: value,
          customer_template: existingNotificationFound.customer_template,
          id: existingNotificationFound.id,
        });
      } else if (notificationConfig.send_to[0] === "Assignee") {
        setNotificationConfig({
          ...notificationConfig,
          [name]: value,
          assignee_template: existingNotificationFound.assignee_template,
          id: existingNotificationFound.id,
        });
      } else {
        setNotificationConfig({
          ...notificationConfig,
          [name]: value,
          id: existingNotificationFound.id,
        });
      }
      setIsNewNotificationConfig(false);
    } else {
      setNotificationConfig({
        ...notificationConfig,
        [name]: value,
        customer_template: "",
        creator_template: "",
        assignee_template: "",
      });
      setIsNewNotificationConfig(true);
    }
  };

  const handleSendToInputChange = (e: any) => {
    const { name, value } = e.target;
    const existingNotificationFound =
      notificationType === "auto_ticket" && ticketNotificationsData.auto
        ? ticketNotificationsData.auto.find(
            (x: any) =>
              x.status_type === notificationConfig.status_type &&
              JSON.stringify(x.send_to) == JSON.stringify([value])
          )
        : notificationType === "manual_ticket" && ticketNotificationsData.manual
        ? ticketNotificationsData.manual.find(
            (x: any) =>
              x.status_type === notificationConfig.status_type &&
              JSON.stringify(x.send_to) == JSON.stringify([value])
          )
        : null;

    if (existingNotificationFound) {
      console.dir(existingNotificationFound);
      if (value === "Creator")
        setNotificationConfig({
          ...notificationConfig,
          [name]: [value],
          creator_template: existingNotificationFound.creator_template,
          id: existingNotificationFound.id,
        });
      else if (value === "Customer")
        setNotificationConfig({
          ...notificationConfig,
          [name]: [value],
          customer_template: existingNotificationFound.customer_template,
          id: existingNotificationFound.id,
        });
      else if (value === "Assignee")
        setNotificationConfig({
          ...notificationConfig,
          [name]: [value],
          assignee_template: existingNotificationFound.assignee_template,
          id: existingNotificationFound.id,
        });
      else
        setNotificationConfig({
          ...notificationConfig,
          [name]: [value],
          id: existingNotificationFound.id,
        });
      setIsNewNotificationConfig(false);
    } else {
      setNotificationConfig({
        ...notificationConfig,
        [name]: [value],
        customer_template: "",
        creator_template: "",
        assignee_template: "",
      });
      setIsNewNotificationConfig(true);
    }
  };

  // Handler for the 'Via' dropdown
  const handleViaInputChange = (e: any) => {
    const { value } = e.target;
    setNotificationConfig((prev: any) => ({
      ...prev,
      via: value,
    }));
  };

  useEffect(() => {
    function setMessageInRespectivetemplate() {
      if (message)
        setNotificationConfig((prev: any) => {
          const updated =
            prev.send_to[0] === "Creator"
              ? {
                  ...prev,
                  creator_template: prev.creator_template.concat(message),
                }
              : prev.send_to[0] === "Customer"
              ? {
                  ...prev,
                  customer_template: prev.customer_template.concat(message),
                }
              : prev.send_to[0] === "Assignee"
              ? {
                  ...prev,
                  assignee_template: prev.assignee_template.concat(message),
                }
              : prev;
          return updated;
        });
    }
    setMessageInRespectivetemplate();
  }, [message]);

  useEffect(() => {
    if (Array.isArray(activeNotificationsData)) {
      if (activeNotificationsData.length > 0) {
        setNotificationConfig((prev: any) => ({
          ...prev,
          creator_template: activeNotificationsData[0]?.creator_template || "",
          assignee_template: activeNotificationsData[0]?.assignee_template || "",
          customer_template: activeNotificationsData[0]?.customer_template || "",
          id: activeNotificationsData[0]?.id
        }));
        setIsNewNotificationConfig(false);
      } else {
        setNotificationConfig((prev: any) => ({
          ...prev,
          creator_template: "",
          assignee_template: "",
          customer_template: "",
          id: undefined
        }));
        setIsNewNotificationConfig(true);
      }
    }
  }, [activeNotificationsData, notificationType]);

  // useEffect(() => {
  //   isNewNotificationConfig && removeProperty("id");
  // }, [isNewNotificationConfig]);

  useEffect(() => {
    if (activeNotificationsData?.length > 0) {
      setNotificationQueryParams({
        team: notificationConfig.team,
        send_to: notificationConfig.send_to,
        send_via: notificationConfig.via,
        creator_template: notificationConfig.creator_template,
        assignee_template: notificationConfig.assignee_template,
        customer_template: notificationConfig.customer_template,
        notification_type: notificationConfig.notification_type,
        workflow: selectedWorkflow,
        actual_status: selectedStatusId,
        status_type: selectedStatusType,
        id: activeNotificationsData[0].id,
      });
    } else {
      setNotificationQueryParams({
        team: notificationConfig.team,
        send_to: notificationConfig.send_to,
        send_via: notificationConfig.via,
        creator_template: notificationConfig.creator_template,
        assignee_template: notificationConfig.assignee_template,
        customer_template: notificationConfig.customer_template,
        notification_type: notificationConfig.notification_type,
        workflow: selectedWorkflow,
        actual_status: selectedStatusId,
        status_type: selectedStatusType,
      });
    }
  }, [
    notificationConfig,
    activeNotificationsData,
    selectedWorkflow,
    selectedStatusId,
    selectedStatusType,
  ]);

  return (
    <>
      <div className="row mt-3">
        <div className="col">
          <span className="input-group-text bg-secondary mt-5">
            <strong>
              {notificationType === "auto_ticket" ? "Auto" : "Manual"} ticket
              rules
            </strong>
          </span>
        </div>
      </div>

      <div className="row mt-5">
        <div className="w-100 mw-200px">
          <label className="d-flex align-items-start">When Status</label>
          {/*begin::Select2*/}
          <select
            className="form-select select2-hidden-accessible"
            name="status_type"
            onChange={handleWhenStatusInputChange}
            value={notificationConfig.status_type}
          >
            <option value="">Select Status</option>
            {Array.isArray(selectedStatus) &&
              selectedStatus.map((statusObj: any, idx: number) => (
                <option key={statusObj.uuid || idx} value={statusObj.uuid}>
                  {typeof statusObj.status === "string"
                    ? statusObj.status
                    : statusObj.status?.status}
                </option>
              ))}
          </select>
          {/*end::Select2*/}
        </div>

        {notificationConfig.status_type !== "" && (
          <>
            <div className="w-100 mw-200px">
              <label className="d-flex align-items-start">Send to</label>
              {/*begin::Select2*/}
              <select
                className="form-select select2-hidden-accessible"
                name="send_to"
                onChange={handleSendToInputChange}
                value={notificationConfig.send_to[0]}
              >
                <option value="select team" hidden>
                  Select
                </option>
                <option value="Customer">Customer</option>
                <option value="Assignee">Assignee</option>
              </select>
              {/*end::Select2*/}
            </div>

            {notificationConfig.send_to[0] && (
              <>
                <div className="w-100 mw-200px ">
                  <label
                    htmlFor="via-select"
                    className="d-flex align-items-start"
                  >
                    Via
                  </label>
                  <select
                    id="via-select"
                    className="form-select select2-hidden-accessible"
                    name="via"
                    onChange={handleViaInputChange}
                    value={notificationConfig.via ?? ""}
                  >
                    <option value="" hidden>
                      Select
                    </option>
                    {/* <option value="SMS">SMS</option>
                    <option value="WhatsApp">WhatsApp</option> */}
                    <option value="Email">Email</option>
                  </select>
                </div>

                {notificationConfig.via && (
                  <>
                    <div className="row gap-5">

                    {notificationConfig.send_to[0] !== "Assignee" && (
                      <div className="w-100 mw-200px mt-5">
                        <div className="d-flex align-items-center">
                          <i className="bi bi-person-add me-2 fs-2 text-dark"></i>
                          <button
                            className="form-control form-control fw-bold"
                            onClick={() => insertPlaceholder("{{assigned_by}}")}
                          >
                            Assigned By
                          </button>
                        </div>
                      </div>
                    )}

                      <div className="w-100 mw-200px mt-5">
                        <div className="d-flex align-items-center">
                          <i className="bi bi-person-check-fill me-2 fs-2 text-dark"></i>
                          <button
                            className="form-control form-control fw-bold"
                            onClick={() => insertPlaceholder("{{sender_name}}")}
                          >
                            Sender Name
                          </button>
                        </div>
                      </div>

                      <div className="w-100 mw-200px mt-5">
                        <div className="d-flex align-items-center">
                          <i className="bi bi-ticket-detailed text-dark fs-2 me-2" />
                          <button
                            className="form-control form-control fw-bold"
                            onClick={() => insertPlaceholder("{{ticket_id}}")}
                          >
                            Ticket ID
                          </button>
                        </div>
                      </div>

                      <div className="w-100 mw-225px mt-5">
                        <div className="d-flex align-items-center">
                          <i className="bi bi-ticket-detailed-fill text-dark fs-2 me-2" />
                          <button
                            className="form-control form-control fw-bold"
                            onClick={() =>
                              insertPlaceholder("{{ticket_description}}")
                            }
                          >
                            Ticket Description
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Text area and label */}
                    <div className="row mt-5">
                      <div className="w-100">
                        <div className="mb-0">
                          <div className="input-group">
                            <span className="input-group-text">Send to:</span>
                            <input
                              type="text"
                              className="form-control"
                              // aria-label="Send to"
                              // aria-describedby="basic-addon1"
                              value={notificationConfig.send_to[0]}
                              readOnly
                            />
                          </div>
                        </div>

                        <textarea
                          id={notificationType === 'auto_ticket' ? 'auto-ticket-textarea' : 'manual-ticket-textarea'}
                          className="form-control"
                          rows={4}
                          placeholder="Enter Message..."
                          value={loadTemplateOf(notificationConfig.send_to[0])}
                          onChange={handleRespectiveFieldtemplateUpdate}
                          onClick={(e) => {
                            const target = e.target as HTMLTextAreaElement;
                            target.selectionStart = target.selectionEnd = target.selectionStart;
                          }}
                        ></textarea>
                      </div>

                      <div className="text-end mt-5">
                        {activeNotificationsData?.length > 0 && (
                          <button
                            className="btn btn-danger ms-2"
                            onClick={async () => {
                              try {
                                await triggerDeleteTicketNotification({
                                  id: activeNotificationsData[0]?.id,
                                });
                                toast.success("Notification deleted!");
                                refetchNotificationData();
                              } catch (error) {
                                toast.error("Failed to delete notification");
                              }
                            }}
                          >
                            Delete
                          </button>
                        )}
                        <button
                          className="btn btn-primary ms-2"
                          onClick={(e) => {
                            isNewNotificationConfig
                              ? triggerNewTicketNotificationConfig(
                                  notificationQueryParams
                                ).then((res: any) => {
                                  if (res.data) {
                                    toast.success("New notification created!");
                                    refetchNotificationData();
                                  }
                                })
                              : triggerEditTicketNotificationConfig(
                                  notificationQueryParams
                                ).then((res: any) => {
                                  if (res.data) {
                                    toast.success("Notification updated!");
                                    refetchNotificationData();
                                  }
                                });
                          }}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AutoTicketRules;
